import type { SVGProps } from "react";

interface PlusIconProps extends SVGProps<SVGSVGElement> {
  strokeColor?: string;
}

const PlusIcon = ({ strokeColor, ...props }: PlusIconProps) => {
  return (
    <svg {...props} width="18" height="18" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5 12H19" stroke={strokeColor || "currentColor"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M12 5V19" stroke={strokeColor || "currentColor"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export default PlusIcon;
